module.exports = __webpack_public_path__ + "static/img/13.ec10eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/13.png
// module id = YjyD
// module chunks = 1